<template lang='pug'>
.document-catalog-container
    h4.page-title {{ title }}
    .tab-wrapper
        .tab(
            :class='{ active: activeIndex === item.id }',
            v-for='(item, index) in tab',
            :key="item.id"
            @click='changeType(item.id)'
        ) {{ item.name }}
    .document-content
        .catalog-list
            .level1-wrapper
                .catalog-list-item(
                    v-for='(item, k) in level1List',
                    @click='showLevel2(item)',
                    :class='{ active: activeLevel1Name[hId] === item.id }'
                ) 
                    span {{ item.name }}
            transition(name='slide')
                .level2-wrapper(v-show='isShowLevel2')
                    .catalog-list-item(
                        v-for='item in level2List',
                        @click='selectLevel2(item)',
                        :class='{ active: activeLevel2Name[hId] === item.id }'
                    ) 
                        span {{ item.name }}
        ListTransition.content-list(
            v-if='activeIndex == DATA.module.documentCatalog.hierarchies.pdf',
            :list='productList',
            rowKey='id',
            anime='translateXLeft',
            v-slot='{ item }'
        )
            .content-list-item(@click='previewPdf(item)')
                img.banner(v-lazy='item.detail.banner')
                .text-wrapper
                    .name {{ item.detail.name }}
                    img(
                        src='@/assets/imgs/star.png',
                        @click.stop='book(item)',
                        v-if='bookList[item.detail.type + item.detail.id]'
                    )
                    img(
                        src='@/assets/imgs/unstar.png',
                        @click.stop='book(item)',
                        v-else
                    )
        ListTransition.content-list.video-wrapper(
            v-else,
            :list='productList',
            rowKey='id',
            anime='translateXLeft',
            v-slot='{ item }'
        )
            .content-list-item
                .video-poster-wrapper(
                    @click='previewVideo(item)'
                )
                    //- @click='$router.push({ name: "videoViewer", params: { rId: item.id }, query: { hId } })'
                    img.video-poster(v-lazy='item.detail.banner', v-if='item.detail.banner')
                    img.video-poster(v-else, v-lazy='item.detail.link', data-poster)
                    img.play(src='@/assets/imgs/play.png')
                .text-wrapper
                    .name {{ item.detail.name }}
                    img(
                        src='@/assets/imgs/star.png',
                        @click.stop='book(item)',
                        v-if='bookList[item.detail.type + item.detail.id]'
                    )
                    img(
                        src='@/assets/imgs/unstar.png',
                        @click.stop='book(item)',
                        v-else
                    )
</template>

<script>
import ListTransition from './components/ListTransition'
import { checkWechatUnique } from '@/service'
import { mapActions, mapState } from 'vuex'
import { addBookmark, deleteBookmark } from '@/service/member'
import confirm from './mixin/index'
import { concatURI, getDataModule, getDataRows, getPathNames } from '@custouch/proxy-use'
const { DATA } = window.env
export default {
    mixins: [confirm],
    name: 'documentCatalog',
    data() {
        return {
            activeIndex: '',
            tab: [],
            // tab: [{ text: '资料下载', type: 'pdf', hId: DATA.module.documentCatalog.hierarchies.pdf }, { text: '精彩视频', type: 'video',  hId: DATA.module.documentCatalog.hierarchies.video }],
            list: { pdf: [], video: [] },
            // activeLevel1Name: { pdf: '全部', video: '全部' },
            // activeLevel2Name: { pdf: '', video: '' },
            isShowLevel2: false,
            DATA,
            title: '',
            allId: 'all',
            activeLevel1Name: { [DATA.module.documentCatalog.hierarchies.pdf]: 'all', [DATA.module.documentCatalog.hierarchies.video]: 'all' },
            activeLevel2Name: { [DATA.module.documentCatalog.hierarchies.pdf]: '', [DATA.module.documentCatalog.hierarchies.video]: '' },
            pdfList: [],
            videoList: [],
            productList: []
        }
    },
    components: {
        ListTransition
    },
    computed: {
        ...mapState(['bookMarks', 'userInfo', 'memberInfo']),
        type() {
            return this.$route.params.type
        },
        hId(){
            return this.$route.query.hId
        },
        // currentActiveLevel1() {
        //     return this.activeLevel1Name[this.hId]
        // },
        // currentActiveLevel2() {
        //     return this.activeLevel2Name[this.hId]
        // },
        bookList() {
            let res = {}
            const bookDic = this.bookMarks.reduce((pre, cur) => {
                pre[cur.detail.type + cur.detail.id] = cur.id
                return pre
            }, {})
            for(let item of this.productList){
                res[item.detail.type + item.detail.id] = bookDic[item.detail.type + item.detail.id]
            }
            // for (let [k, values] of Object.entries(this.list)) {
            //     values.forEach(item => {
            //         res[k + item.id] = bookDic[k + item.id]
            //     })
            // }
            return res
        },
        level1List() {
            // const target = this.list[this.type]
            const info = this.tab.find(item=>item.id === this.hId)
            if(info){
                return [{name: '全部', id: this.allId},...info.dataHierarchies]
            }
            return []
            // let res = {}
            // target && target.forEach(item => {
            //     if (!res[item.level1]) {
            //         res[item.level1] = item.level2 ? ['全部类别', item.level2] : []
            //     } else if (item.level2 && !res[item.level1].includes(item.level2)) {
            //         res[item.level1].push(item.level2)
            //     }
            // })
            // return Object.assign({ '全部': [] }, res)
        },
        level2List(){
            let info = this.level1List.find(item=>item.id === this.activeLevel1Name[this.hId])
            if(info && info.dataHierarchies?.length){
                return [{name: '全部类别',id: this.allId},...info.dataHierarchies]
            }
            return []
        },
        // productList() {
        //     if(this.hId === DATA.module.documentCatalog.hierarchies.pdf){
        //         list = this.pdfList
        //     }else if(this.hId === DATA.module.documentCatalog.hierarchies.video){
        //         list = this.videoList
        //     }
        //     if(list.length){
        //         if(this.activeLevel1Name[this.hId] === this.allId) return list
        //         if(this.level2List.length){
        //             if(!this.activeLevel2Name[this.hId]) return []
        //             if(this.activeLevel2Name[this.hId] === this.allId){
        //                 let info = this.level1List.find(item=>item.id === this.activeLevel1Name[this.hId])
        //                 if(info && info.dataHierarchies.length){
        //                     let ids = [...info.dataHierarchies.map(item=>item.id),info.id]
        //                     return list.filter(item=>item.dataHierarchyIds.find(hId=>ids.includes(hId)))
        //                 }
        //             }else{
        //                 return list.filter(item=>item.dataHierarchyIds.includes(this.activeLevel2Name[this.hId]))
        //             }
        //         }else{
        //             return list.filter(item=>item.dataHierarchyIds.includes(this.activeLevel1Name[this.hId]))
        //         }
        //     }
        //     if(this.hId === DATA.module.documentCatalog.hierarchies.pdf){
        //         if(this.currentActiveLevel1 === this.allId) return this.pdfList
        //         if(this.level2List && this.level1List.length){
        //             if(!this.currentActiveLevel2) return []
        //             // if(this.currentActiveLevel2 === this.allId) return 
        //         }
        //     }
        //     return []
        //     // const list = this.list[this.type], currentLevel2 = this.level1List[this.currentActiveLevel1]
        //     // if (!list) return []
        //     // if (this.currentActiveLevel1 === '全部') return list
        //     // if (currentLevel2 && currentLevel2.length) {
        //     //     if (!this.currentActiveLevel2) return []
        //     //     if (this.currentActiveLevel2 === '全部类别') return list.filter(item => this.currentActiveLevel1 === item.level1)
        //     //     return list.filter(item => this.currentActiveLevel1 === item.level1 && this.currentActiveLevel2 === item.level2)
        //     // }
        //     // return list.filter(item => this.currentActiveLevel1 === item.level1)
        // }
    },
    methods: {
        ...mapActions(['getBookmarks']),
        async book(item) {
            try {
                if (!this.memberInfo.id) {
                    this.showConfirm()
                    return
                }
                const id = this.bookList[item.detail.type + item.detail.id]
                if (id != null) {
                    await deleteBookmark(id)
                    this.$message.success('取消收藏成功')
                } else {
                    await addBookmark({
                        name: item.detail.name,
                        url: window.location.href,
                        detail: {
                            id: item.detail.id,
                            type: item.detail.type,
                            rId: item.id
                        }
                    })
                    this.$message.success('收藏成功')
                }
                this.getBookmarks(true)
            } catch (error) {
                this.$message.fail(error.message)
            }
        },
        async previewPdf(item) {
            const { id, name } = item.detail
            let route = {
                name: 'pdfViewer',
                params: {
                    rId: item.id
                }
            }
            route = this.getRoute(route)
            this.$router.push(route)
            // if (window.env.NODE_ENV !== 'development' && await checkWechatUnique('737109750218719232')) {
            //     window.location.href = concatURI('https://form.cloud.custouch.com/show/737109750218719232',{
            //         fileid: id,
            //         c_filename: name,
            //         c_default_redirect: route.query.hId ? `${window.location.origin}/#/pdfViewer/${item.id}?hId=${route.query.hId}` : `${window.location.origin}/#/pdfViewer/${item.id}`
            //     })
            //     // window.location.href = `https://form.cloud.custouch.com/show/737109750218719232?fileid=${id}&c_filename=${name}&c_rId=${item.id}`
            // } else {
            //     this.$router.push(route)
            //     // this.$router.push({ name: 'pdfViewer', params: { rId: item.id } })
            // }
        },
        previewVideo(item){
            let route = {
                name: 'videoViewer',
                params: {
                    rId: item.id
                }
            }
            route = this.getRoute(route)
            this.$router.push(route)
        },
        getRoute(route){
            if(this.activeLevel2Name[this.hId] && this.activeLevel2Name[this.hId] !== this.allId){
                Object.assign(route,{
                    query: {
                        hId: this.activeLevel2Name[this.hId]
                    }
                })
            }else if(this.activeLevel1Name[this.hId] !== this.allId){
                Object.assign(route, {
                    query: {
                        hId: this.activeLevel1Name[this.hId]
                    }
                })
            }else{
                Object.assign(route,{
                    query: {
                        hId: this.hId
                    }
                })
            }
            return route
        },
        async selectLevel2(item) {
            // this.activeLevel2Name[this.type] = item
            this.isShowLevel2 = false
            if(this.activeLevel2Name[this.hId] === item.id) return
            this.activeLevel2Name[this.hId] = item.id
            if(this.activeLevel2Name[this.hId] !== this.allId){
                this.$router.replace({query: {hId: this.hId,pId: item.id}})
            }else{
                this.$router.replace({query: {hId: this.hId,pId: this.activeLevel1Name[this.hId]}})
            }
        },
        async showLevel2(item) {
            if(this.activeLevel1Name[this.hId] !== item.id){
                this.activeLevel1Name[this.hId] = item.id
                this.activeLevel2Name[this.hId] = ''
                if(this.activeLevel1Name[this.hId] !== this.allId){
                    if(!(item.dataHierarchies && item.dataHierarchies.length)){
                        this.$router.replace({query: {hId: this.hId,pId: item.id}})
                    }
                }else{
                    this.$router.replace({query: {hId: this.hId}})
                }
            }
            if(item.detail?.link){
                window.location.href = item.detail.link
                return
            }
            this.isShowLevel2 = item.dataHierarchies && item.dataHierarchies.length
            // this.isShowLevel2 = !!this.level1List[k].length
            // this.activeLevel1Name[this.type] = k
            // this.$nextTick(() => {
            //     if (this.productList[0] && this.productList[0].isLink) {
            //         window.location.href = this.productList[0].link
            //     }
            // })
        },
        getPId(data, pId){
            let level1Info = data.dataHierarchies.find(item=>item.id === pId)
            if(level1Info){
                this.activeLevel1Name[this.hId] = pId
                if(level1Info.dataHierarchies.length){
                    this.activeLevel2Name[this.hId] = 'all'
                }
                return
            }
            let list = data.dataHierarchies.map(item=>item.dataHierarchies)
            list.map((item,index)=>{
                let info = item.find(key=>key.id === pId)
                if(info){
                    this.activeLevel2Name[this.hId] = pId
                    this.activeLevel1Name[this.hId] = data.dataHierarchies[index].id
                }
            })
        },
        async changeType(hId) {
            // const index = this.tab.findIndex(_ => _.hId === hId)
            if (this.$route.query.hId !== hId) {
                // this.$router.replace({ params: { type } })
                this.$router.replace({ query: { hId } })
            }
            if(this.$route.query.pId){
                let data = this.tab.find(item=>item.id === hId)
                if(data){
                    this.getPId(data,this.$route.query.pId)
                }
            }
            if(this.activeIndex !== hId){
                if(this.activeLevel2Name[hId] && this.activeLevel2Name[hId] !== this.allId){
                    this.$router.replace({query: {hId, pId: this.activeLevel2Name[hId]}})
                }else if(this.activeLevel1Name[hId] && this.activeLevel1Name[hId] !== this.allId){
                    this.$router.replace({query: {hId, pId: this.activeLevel1Name[hId]}})
                }
            }
            this.activeIndex = hId
        },
        async getList(hId){
            const { module, template } = DATA
            let tId = ''
            if(this.hId === module.documentCatalog.hierarchies.pdf){
                tId = template.docsPdf
            }else{
                tId = template.docsVideo
            }
            const res = await getDataRows({
                dataTemplateId: tId,
                dataHierarchyId: hId,
                index: 1,
                size: 999,
                orderBy: 'index',
                desc: false
            })
            return res.data
        },
        async reportTitle(hId){
            if(!hId) return
            let title = await getPathNames(hId)
            this.$root.$emit('pageview',{
                title
            })
        }
    },
    watch: {
        '$route.query': {
            async handler(val){
                const { hId,pId } = val
                if(pId){
                    this.productList = await this.getList(pId)
                    this.reportTitle(pId)
                }else if(hId){
                    this.productList = await this.getList(hId)
                    this.reportTitle(hId)
                }else{
                    this.productList = []
                }
            },
            deep: true,
            immediate: true
        }
    },
    async created() {
        const { module, template } = DATA
        const ret = await getDataModule({dataModuleId: module.documentCatalog.id})
        // const [ ret, { data: pdfData }, { data: videoData } ] = await Promise.all([
        //     getDataModule({dataModuleId: module.documentCatalog.id}),
        //     getDataRows({
        //         dataHierarchyId: module.documentCatalog.hierarchies.pdf,
        //         dataTemplateId: template.docsPdf,
        //         index: 1,
        //         size: 999,
        //         includeParentDataHierarchyIds: true,
        //         recursive: true
        //     }),
        //     getDataRows({
        //         dataHierarchyId: module.documentCatalog.hierarchies.video,
        //         dataTemplateId: template.docsVideo,
        //         index: 1,
        //         size: 999,
        //         includeParentDataHierarchyIds: true,
        //         recursive: true
        //     }),
        // ])
        this.title = ret.name
        this.tab = ret.dataHierarchies
        this.changeType(this.$route.query.hId ?? module.documentCatalog.hierarchies.pdf)
        // this.pdfList = pdfData
        // this.videoList = videoData
        // const data = await this.$store.dispatch('getJson', window.env.VUE_APP_DATA_DOCUMENT)
        // this.list = data.reduce((pre, cur) => {
        //     if (cur.level1 || cur.level2) {
        //         if (cur.type === 'pdf') {
        //             pre.pdf.push(cur)
        //         } else {
        //             pre.video.push(cur)
        //         }
        //     }
        //     return pre
        // }, { pdf: [], video: [] })
    }
}
</script>

<style scoped lang='less'>
@import '~@/assets/style/mixin';
@level1WrapperWidth: 5.5rem;
.document-catalog-container {
    overflow: hidden;
}
.page-title {
    text-align: center;
    color: @titleColor;
    font-size: 1rem;
    margin: 1.2rem 0;
}
.tab-wrapper {
    display: flex;
    justify-content: center;
    font-size: 0.7rem;
    .tab {
        background: #fff;
        border: 1px solid @borderColor;
        background: #fff;
        border-left: 0;
        width: 6.8rem;
        height: 1.65rem;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        transition: all 0.5s ease-in;
        &:first-child {
            border-left: 1px solid @borderColor;
            box-shadow: none;
        }
    }
    .active {
        color: #fff;
        background: @themeColor;
        border-color: @themeColor!important;
        box-shadow: -1px 0 0 0 @themeColor;
    }
}
.document-content {
    width: 100%;
    border-top: 1px solid @borderColor;
    margin-top: @spacing;
    height: calc(100vh - 1.65rem - 2.4rem - 1.45rem - 0.5rem - @navHeight);
}
.catalog-list {
    position: absolute;
    display: flex;
    height: calc(100vh - 1.65rem - 2.4rem - 1.45rem - 0.5rem - @navHeight);
    &-item {
        padding-left: 0.8rem;
        position: relative;
        width: 100%;
        line-height: 2.3rem;
        transition: color 0.5s ease-in;
        border-bottom: 1px solid @borderColor;
    }

    .level1-wrapper,
    .level2-wrapper {
        position: relative;
        border-right: 1px solid @borderColor;
        background: #fff;
        z-index: 1;
        overflow-y: auto;
        height: 100%;
    }
    .level2-wrapper {
        .catalog-list-item {
            padding-right: 0.8rem;
        }
    }
    .cover {
        position: absolute;
        width: calc(100vw - @level1WrapperWidth);
        height: 100%;
        z-index: 1;
    }
    .level1-wrapper {
        width: @level1WrapperWidth;
        z-index: 2;
    }
    .select-status {
        position: absolute;
        right: @spacing;
        top: 50%;
        height: 0.55rem;
        object-fit: contain;
        margin-top: -0.55/2rem;
    }
    .active {
        color: @themeColor;
    }
}
.content-list {
    position: relative;
    overflow-y: auto;
    margin-left: @level1WrapperWidth;
    height: 100%;
    width: calc(100% - @level1WrapperWidth);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 1rem;
    &-item {
        display: flex;
        flex-direction: column;
        .play {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 1.8rem;
            object-fit: contain;
        }
        .video-poster-wrapper {
            position: relative;
        }
        .video-poster {
            width: 100%;
            object-fit: contain;
            filter: brightness(60%);
        }
    }
    .banner {
        width: 100%;
        height: 7rem;
        object-fit: contain;
        object-position: bottom;
    }
    video {
        width: 100%;
    }
    .text-wrapper {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin: 0.4rem 0;
        img {
            width: 0.75rem;
            object-fit: contain;
            margin-left: 2px;
        }
    }
    .name {
        font-size: 0.65rem;
        // max-width: 5rem;
    }
}
.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s ease-in;
}
.slide-enter,
.slide-leave-to {
    opacity: 0;
    transform: translateX(-100%);
}
</style>
<style lang="less">
.document-catalog-container {
    .list-item {
        width: 44%;
        margin-bottom: 0.5rem;
    }
    .video-wrapper {
        display: block;
        .list-item {
            width: 100%;
        }
    }
}
</style>